import { useLocation, useNavigate } from "react-router-dom";
import React, { useLayoutEffect } from "react";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";

import MainContainer from "../../../layout/MainContainer";
import "../Users.scss";
import { Details } from "../../../features";

import WishListUser from "../../../features/users/Wishlist";

import OrderDetails from "../../../features/users/OrderDetails";
import CustomerDocuments from "../../../features/users/CustomerDocuments";
import useTranslation from "../../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const UserDetails = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state, "state");
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // useLayoutEffect(() => {
  //   if (state) {
  //     setValue(state);
  //   }
  // }, []);
  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.viewUserProfile}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-users", { state: { value: state?.value } });
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label={t.main.details} {...a11yProps(0)} />
                <Tab label={t.main.documents} {...a11yProps(1)} />
                {/* <Tab label="Order Details" {...a11yProps(1)} /> */}
                {/* <Tab label="Contacted Agents" {...a11yProps(1)} /> */}
                {/* <Tab label="Wishlist" {...a11yProps(1)} /> */}
                {/* <Tab label="Saved searches" {...a11yProps(1)} /> */}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Details />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <CustomerDocuments />
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={2}>
              <OrderDetails />
            </CustomTabPanel> */}
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default UserDetails;
